import {
  Player,
  Controls,
  PlayerEvent,
} from "@lottiefiles/react-lottie-player";
import { useState } from "react";

export const LottiePlayer = () => {
  const [visible, setVisible] = useState(true);

  const handleEventChange = (e) => {
    // console.log("handleEventChange", e);
    if (e === PlayerEvent.Complete) {
      setVisible(false);
    }
  };

  return (
    visible && (
      <Player
        autoplay
        src="/assets/62717-confetti.json"
        className="absolute left-0 top-0 w-full h-full"
        onEvent={handleEventChange}
      >
        <Controls />
      </Player>
    )
  );
};
